import React, { useEffect, useContext } from 'react';
import SideMenu from 'layout/side-menu';
import { useOutlet } from 'react-router-v6';
import { Layout, ConfigProvider } from 'antd';
import '../scss/main.scss';
import { getUserBots } from 'api-services/container';
import { useNavigate } from 'react-router-v6';
import ChatBotContext from 'hooks/chat-bot-context';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import AuthService from 'api-services/auth-service';

import { useTitle } from 'hooks/UseTitle';
import useLoading from 'hooks/use-loading';
import useDecodeToken from 'hooks/use-decode-token';

const { Content, Sider } = Layout;

function Container() {
  useTitle('Chat Buddy Pro');

  const location = useLocation();
  const { botName } = useContext(ChatBotContext);
  const { subscriptionId, planId, userId } = useDecodeToken();
  const { skeleton, setSkeleton } = useLoading();

  const outlet = useOutlet();
  const navigate = useNavigate();

  useEffect(() => {
    if (!AuthService.isAuthenticated()) {
      navigate('/login');
      return;
    }

    if (subscriptionId === null && planId === null) return;

    if (!(subscriptionId, planId)) {
      navigate('/pricing', { state: { hideSideBar: true } });
    } else if (userId && location.pathname === '/') {
      getBotsData();
    }
  }, [subscriptionId, planId, location.pathname]);

  const getBotsData = async () => {
    try {
      setSkeleton(true);
      const result = await getUserBots(userId);
      if (result.status === 200) {
        if (result?.data?.length === 0) {
          navigate('/data-source', { state: { hideSideBar: true } });
        }
      }
      navigate('/chatbots', { state: { hideSideBar: false } });
    } catch (e) {
      console.log(e);
    } finally {
      setSkeleton(false);
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#6754E2',
        },
      }}>
      <Layout className='app-layout'>
        {botName ? (
          <HelmetProvider>
            <Helmet>
              <title>{botName}</title>
            </Helmet>
          </HelmetProvider>
        ) : (
          <></>
        )}

        {!location?.state?.hideSideBar ? (
          <Sider breakpoint='xl' collapsible collapsedWidth='0' width='250'>
            <SideMenu />
          </Sider>
        ) : (
          <></>
        )}

        <Content className={skeleton ? 'outlet-container-hide' : 'outlet-container'}>
          <div className='site-layout-background'>{outlet}</div>
        </Content>
      </Layout>
    </ConfigProvider>
  );
}

export default Container;
